/* eslint-disable @typescript-eslint/no-explicit-any */

import dayjs, { Dayjs } from "dayjs";
import { SubServiceType } from "../../../../../../PotentialDeals/ducks/types";

export function updateSubServiceQty(
  fullServiceData: any[],
  targetServiceLineId: string,
  targetServiceGroupId: string,
  record: SubServiceType,
  newQty: string,
  newGM?: string
): any[] {
  return fullServiceData.map((serviceLine) => {
    if (serviceLine.service_line_id === targetServiceLineId) {
      const updatedServiceGroups = serviceLine?.service_groups?.map(
        (serviceGroup: any) => {
          let calculatedHours = 0;
          if (serviceGroup.id === targetServiceGroupId) {
            const updatedServices = serviceGroup.services.map(
              (service: any) => {
                if (service.entity_id === record?.entity_id) {
                  if (record?.production_rate_type === "unit_per_hour") {
                    calculatedHours =
                      newQty && record?.prod_rate
                        ? Number(newQty) / record?.prod_rate
                        : 0;
                  } else {
                    calculatedHours =
                      newQty && record?.prod_rate
                        ? Number(newQty) * record?.prod_rate
                        : 0;
                  }
                  console.log("Service Group ID:--", service);
                  const totalCost =
                    service?.total_labor_cost + service?.total_material_cost;
                  console.log("newGM:--", newGM);
                  return {
                    ...service,
                    qty: newQty ? Math.round(Number(newQty)) : service?.qty,
                    labor_hrs: calculatedHours,
                    total_labor_cost: Math.round(
                      calculatedHours * (serviceLine?.labor_rate || 0)
                    ),
                    total_cost: totalCost,
                    total_price: newGM
                      ? (totalCost * 100) / (100 - +newGM)
                      : (totalCost * 100) / (100 - +service?.total_price),
                    gross_margin_perc: newGM
                      ? Number(newGM)
                      : service?.gross_margin_perc,
                    material: service?.material?.map((mat: any) => {
                      return {
                        ...mat,
                        total_cost: Number(newQty) * mat?.unit_cost,
                        total_need:
                          mat?.unit_order ===
                          "category_unit_per_measurement_unit"
                            ? Math.round(Number(newQty) / mat?.use_rate) *
                              (service?.frequency !== "one_time"
                                ? service?.visit
                                : 1)
                            : Math.round(Number(newQty) * mat?.use_rate) *
                              (service?.frequency !== "one_time"
                                ? service?.visit
                                : 1),
                      };
                    }),
                  };
                }
                return service;
              }
            );

            return {
              ...serviceGroup,
              services: updatedServices,
            };
          }
          return serviceGroup;
        }
      );
      return {
        ...serviceLine,
        service_groups: updatedServiceGroups,
      };
    }
    return serviceLine;
  });
}

export function calculateServiceIntervals(
  startDateString: string,
  endDateString: string,
  frequency: string
): number {
  const startDate: Dayjs = dayjs(startDateString);
  const endDate: Dayjs = dayjs(endDateString);

  // 1. Validate the input dates
  if (!startDate.isValid() || !endDate.isValid()) {
    console.error(
      "calculateServiceIntervals: Invalid start or end date provided."
    );
    return 0;
  }

  // 2. Handle cases where the start date is after the end date
  if (startDate.isAfter(endDate)) {
    // If the contract ends before it starts, no intervals are covered.
    return 0;
  }

  let durationInUnits: number;

  // 3. Calculate the duration based on the frequency type
  switch (frequency) {
    case "weekly":
      // For weekly/bi_weekly, calculate duration in days and divide by the respective number of days.
      // Using `true` as the third argument to `diff` returns a floating-point number.
      durationInUnits = endDate.diff(startDate, "day", true);
      return durationInUnits / 7;
    case "bi_weekly":
      durationInUnits = endDate.diff(startDate, "day", true);
      return durationInUnits / 14;
    case "monthly":
      // For monthly/quarterly, calculate duration in months directly.
      // `dayjs().diff(other, 'month', true)` provides fractional months, which aligns with
      // the "duration / frequency" concept.
      durationInUnits = endDate.diff(startDate, "month", true);
      return durationInUnits;
    case "quarterly":
      durationInUnits = endDate.diff(startDate, "month", true);
      return durationInUnits / 3;
    default:
      // Handle unsupported frequencies
      console.warn(
        `calculateServiceIntervals: Unknown frequency '${frequency}'. Returning 0.`
      );
      return 0;
  }
}

export function updateServiceLineGM(
  fullServiceData: any[],
  targetServiceLineId: string,
  newQty: string
): any[] {
  return fullServiceData.map((serviceLine) => {
    if (serviceLine.service_line_id === targetServiceLineId) {
      return {
        ...serviceLine,
        gross_margin_perc: Number(newQty),
        total_price: serviceLine.total_cost
          ? Math.round((serviceLine.total_cost * 100) / 100 - Number(newQty))
          : 0,
      };
    }
    return serviceLine;
  });
}

export function updateSimpleService(
  groupIndex: number,
  serviceIndex: number,
  newQty: string,
  setGroupedData: (data: any) => void,
  totalCost: number,
  serviceGM?: number
) {
  interface SimpleService {
    qty: number;
    total_cost: number;
    [key: string]: any;
  }

  interface ServiceGroup {
    services: SimpleService[];
    [key: string]: any;
  }

  type GroupedData = ServiceGroup[];

  setGroupedData((prevData: GroupedData) => {
    const newData: GroupedData = [...prevData];
    const currentGroup: ServiceGroup = {
      ...newData[groupIndex],
    };

    console.log(
      "p.services[serviceIndex]",
      currentGroup.services[serviceIndex]
    );

    currentGroup.services[serviceIndex].gross_margin_perc = Number(serviceGM);
    newData[groupIndex] = currentGroup;

    if (newQty) {
      currentGroup.services[serviceIndex].qty = Number(newQty);
    }
    if (totalCost) {
      currentGroup.services[serviceIndex].total_cost = totalCost;

      currentGroup.total_cost =
        currentGroup.services
          .filter(
            (service: SimpleService) => service.index !== serviceIndex + 1
          )
          .reduce(
            (acc: number, service: SimpleService) => acc + service.total_cost,
            0
          ) + totalCost;
    }

    if (totalCost && serviceGM) {
      currentGroup.services[serviceIndex].total_price = Math.round(
        (totalCost * 100) / (100 - (serviceGM ?? 0))
      );

      currentGroup.total_price = Math.round(
        (totalCost * 100) / (100 - (serviceGM ?? 0))
      );
    }

    newData[groupIndex] = currentGroup;
    return newData;
  });
}

export function updateServiceWithSub(
  groupIndex: number,
  recordIndex: number,
  newQty: string,
  setGroupedData: (data: any) => void,
  totalCost: number,
  serviceGM?: number
) {
  interface SimpleService {
    qty: number;
    total_cost: number;
    [key: string]: any;
  }

  interface ServiceGroup {
    services: SimpleService[];
    [key: string]: any;
  }

  type GroupedData = ServiceGroup[];

  setGroupedData((prevData: GroupedData) => {
    const newData: GroupedData = [...prevData];
    const currentGroup: ServiceGroup = {
      ...newData[groupIndex],
    };

    const serviceIndex = currentGroup?.service_groups[recordIndex];
    serviceIndex.gross_margin_perc = Number(serviceGM);
    serviceIndex.total_cost = totalCost;
    serviceIndex.total_price = Math.round(
      (totalCost * 100) / (100 - (serviceGM ?? 0))
    );

    console.log("newQty", newQty, serviceGM, totalCost);
    console.log("recordIndex", serviceIndex, currentGroup);

    // currentGroup.services[serviceIndex].gross_margin_perc = Number(serviceGM);
    // newData[groupIndex] = currentGroup;

    // currentGroup.services[serviceIndex].qty = Number(newQty);
    // currentGroup.services[serviceIndex].total_cost = totalCost;
    // currentGroup.services[serviceIndex].total_price = Math.round(
    //   (totalCost * 100) / (100 - (serviceGM ?? 0))
    // );

    // currentGroup.total_cost =
    //   currentGroup.services
    //     .filter((service: SimpleService) => service.index !== serviceIndex + 1)
    //     .reduce(
    //       (acc: number, service: SimpleService) => acc + service.total_cost,
    //       0
    //     ) + totalCost;

    // currentGroup.total_price = Math.round(
    //   (totalCost * 100) / (100 - (serviceGM ?? 0))
    // );
    newData[groupIndex] = currentGroup;
    console.log("newData", newData);
    return newData;
  });
}
